/**
 * @author salla.sai shiva
 * @Date: 2022-11-04 16:20:30
 * @Last Modified by: salla.sai shiva
 * @Last Modified time: 2022-11-04 16:50:30
*/

import { PDF_IMPORTS } from '../../../devUtils/assests';

// const ANNUAL_REPORTS_IPO = {
//   ANNUAL_REPORTS_19_20: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2019-20.pdf',
//   ANNUAL_REPORTS_20_21: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2020-21.pdf',
//   ANNUAL_REPORTS_21_22: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/annual-report-2021-22.pdf',
// };

const COLLAPSE_ANNUAL_FINANCIALS = Object.freeze({
  RELATED_PART_TRANSACTIONS: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/financials/related-party-transaction-30-09-2023.pdf',
  FINANCIALS_COLLAPSE: [
    // {
    //   keyIndex: 1,
    //   headers: 'Annual Reports',
    //   dataSlug: [
    //     // {
    //     //   id: 0,
    //     //   title: 'Annual Report - 2019-20',
    //     //   dataUrl: ANNUAL_REPORTS_IPO.ANNUAL_REPORTS_19_20,
    //     // },
    //     // {
    //     //   id: 1,
    //     //   title: 'Annual Report - 2020-21',
    //     //   dataUrl: ANNUAL_REPORTS_IPO.ANNUAL_REPORTS_20_21,
    //     // },
    //     // {
    //     //   id: 2,
    //     //   title: 'Annual Report - 2021-22',
    //     //   dataUrl: ANNUAL_REPORTS_IPO.ANNUAL_REPORTS_21_22,
    //     // },
    //   ],
    // },
  ],
  CORPORATE_COLLAPSE: [
    // {
    //   keyIndex: 0,
    //   headers: 'Board of Directors',
    //   dataSlug: [
    //     {
    //       id: 0,
    //       title: 'Board of Directors',
    //       dataUrl: PDF_IMPORTS.BOD,
    //     },
    //   ],
    // },
    {
      keyIndex: 2,
      headers: 'Governance Policies',
      dataSlug: [
        {
          id: 0,
          title: 'Whistle Blower Policy',
          dataUrl: PDF_IMPORTS.WHISTLE_BLOWER_POLICY,
        },
        {
          id: 1,
          title: 'Corporate Social Responsibility Policy',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/governance-policies/corporate-social-responsibility-policy.pdf',
        },
        {
          id: 3,
          title: 'Policy for determination of materiality',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-for-determining-materiality-of-an-event-or-information.pdf',
        },
        {
          id: 13,
          title: 'Policy on Preservation of Documents',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/governance-policies/policy-on-preservation-of-documents.pdf',
        },
        {
          id: 4,
          title: 'Archival Policy',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/governance-policies/policy-on-archival-of-documents.pdf',
        },
        {
          id: 5,
          title: 'Policy on Material Subsidiaries',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-for-determining-material-subsidiaries.pdf',
        },
        {
          id: 6,
          title: 'Details of Familiarization Programmes Imparted',
          dataUrl: PDF_IMPORTS.DETAILS_OF_FAMILIARIZATION_PROGRAMMES_IMPARTED,
        },
        {
          id: 7,
          title: 'Letter of appointment for Independent Directors',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/terms-and-conditions-of-appointment-of-independent-directors.pdf',
        },
        {
          id: 8,
          title: 'Related Party Transaction Policy',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/policy-on-materiality-of-and-dealing-with-related-party-transactions.pdf',
        },
        {
          id: 9,
          title: 'Nomination and Remuneration Policy',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/nomination-and-remuneration-policy.pdf',
        },
        {
          id: 10,
          title: 'Policy on Board Diversity',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/governance-policies/policy-on-diversity-of-board-of-directors.pdf',
        },
        {
          id: 11,
          title: 'Dividend Distribution Policy',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/dividend-distribution-policy.pdf',
        },
      ],
    },
    {
      keyIndex: 3,
      headers: 'Corporate Announcement',
      dataSlug: [],
    },
  ],
  RESOURCES_COLLAPSE: [
    {
      keyIndex: 0,
      headers: 'Investor Relations - Contact Details',
      dataSlug: [
        {
          id: 0,
          title: `
            <strong>Corporate Office:</strong>
            <p>
              Boomerang Building,
              Ground Floor, B-1004,<br />
              Yadav Nagar, Chandivali. Powai,<br />
              Mumbai- 400072<br />
              Ph: <a href="tel:02248794879"> 022 4879 4879</a>
            </p><br />
            <strong>Registered Office:</strong>
            <p>
              CSR Estate, Plot No.8, Sector - 1 HUDA Techno Enclave, HITEC City, Hyderabad, Telangana - 500081.<br />
              Mob: <a href="tel:040-23119049">+91 40 2311 9049</a>
            </p>
          `,
        },
      ],
    },
  ],
  DISCLOSURES_COLLAPSE: [
    {
      keyIndex: 0,
      headers: 'Disclosures Under Regulation 46 of The LODR',
    },
  ],
  SHAREHOLDER_INFORMATION_COLLAPSE: [
    {
      keyIndex: 0,
      headers: 'Shareholding Pattern',
      dataSlug: [
        {
          id: 0,
          title: 'Shareholding Pattern - 20.09.2023',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/shareholding-pattern/shareholding-pattern-20th-sep-2023.pdf',
        },
        {
          id: 1,
          title: 'Shareholding Pattern - 30.09.2023',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/shareholding-pattern/shareholding-pattern-30th-sep-2023.pdf',
        },
      ],
    },
    {
      keyIndex: 1,
      headers: 'Notice Of Board Meeting',
      dataSlug: [
        {
          id: 1,
          title: 'Board Meeting - 07.11.2023',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/notice-of-board-meeting/board-meeting-07.11.2023.pdf',
        },
        {
          id: 0,
          title: 'Board Meeting - 11.10.2023',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/notice-of-board-meeting/board-meeting-11.10.2023.pdf',
        },
      ],
    },
    {
      keyIndex: 2,
      headers: 'General Meetings',
      dataSlug: [
        {
          id: 1,
          title: 'Postal Ballot notice - 07.11.2023',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/general-meetings/postal-ballot-notice-07-11-2023.pdf',
        },
        {
          id: 2,
          title: 'Voting Results & Scrutinizer’s Report',
          dataUrl: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/shareholder-information/general-meetings/voting-results-scrutinizers-report.pdf',
        },
      ],
    },
    {
      keyIndex: 3,
      headers: 'Registrar And Share Transfer Agent',
      dataSlug: [],
    },
    {
      keyIndex: 4,
      headers: 'Contact Details For Investor Grievance Redressal',
      dataSlug: [],
    },
    {
      keyIndex: 5,
      headers: 'General',
      dataSlug: [],
    },
  ],
});


export {
  COLLAPSE_ANNUAL_FINANCIALS,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/AnnualGeneralMeeting/constants.js